<template>
  <div class="discussion discussion-instagram">
    <div class="detail-event-header">
            <AvatarComponent :typeNetwork="page.network" :urlPicture="page.avatar"></AvatarComponent>
            
            <div class="info">
                <div class="namePage">
       
                  {{ getRecipientInfo().username }}
                  
                </div>
                <div class="typeEvent">
                    <p>Discussion privée</p>
                </div>
            </div>
            <div class="selectActionEvent">
                <SelectComponent :changeValueSelect="changeStatus" :data="{treated:$t('dash.inbox.state.treated'),waiting:$t('dash.inbox.state.waiting')}" :valueSelect="[1, 3].includes(event.status) ? 'treated' : 'waiting'" :positionY="'bottom'" :positionAuto="false"></SelectComponent>
            </div>
    </div>
    <ul v-if="!isLoading && Object.keys(infoConversation).length" class="discussion-order scrollable" ref="discussionScrool">
      <li v-for="(discut, key) in messages.data" :key="key">
          <div v-if="(discut.message.length || discut.attachments) && (!messages.data[key+1] || new Date(discut.created_time).getTime() - new Date(messages.data[key+1].created_time).getTime() > 900000)" class="date">{{ dateFormat(discut.created_time) }}</div>
          
          <div v-if="discut.from.id != page.network_id" class="message-received">
           
            <div class="story" v-if="discut.story && discut.story.reply_to">
              <p>A réagi à votre story</p>
              <img v-if="discut.story.reply_to.link" :src="discut.story.reply_to.link">
            </div>
           <div class="message-received-content">
            <div class='message-received-content-text' :class="{'text':discut.message && discut.message.length}">
               <p v-if="discut.message.length">{{ discut.message }}</p>
               <img v-if="discut.attachments" class="message-received-content-image" :src="discut.attachments.data[0].image_data.url"/>
              
               <div class="containerReactions" :class="{'isHide' : true}">
                 <div class="reactions">
                   <i>😀</i>
                   <i class="fa-regular fa-face-smile"></i>
                 </div>
               </div>
             </div>
             <!-- <i class="fa-solid fa-ellipsis-vertical"></i> -->
           
           </div>
           <div class="container-actions-message"></div>
          </div> 

          <div v-else-if="discut.from.id == page.network_id" class="message-sent">
            <div class="message-sent-content">
              <!-- <ContextMenu :options="[{label: $t('dash.button.delete'), name : 'deleteComment'}]" :id="discut.id" v-on:clickOption="clickOptionMessage">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </ContextMenu> -->
             
              <div class='message-sent-content-text' :class="{'text':discut.message && discut.message.length}">
                
                
                <p v-if="discut.message && discut.message.length">{{ discut.message }}</p>
                
                <img class="message-received-content-image" v-if="discut.attachments && (typeof discut.attachments.data[0].image_data) !== 'undefined'" :src="discut.attachments.data[0].image_data.url" />

                <div class="containerReactions" :class="{'isHide' : true}">
                  <div class="reactions">
                    <i>😀</i>
                    <i class="fa-regular fa-face-smile"></i>
                  </div>
                </div>
              
              </div>     
            </div>

        
  
              <div class="container-actions-message" >
                
                <div class="" v-if="discut.status && discut.status == 'echec'">Echec de l'envoi</div>
                <div class="" v-else-if="getIndexLastMessageSend == key">Envoyé</div>
              </div>
            
          </div>
      </li>

      <li class="loading-other-message">
        <div v-if="messages.paging && messages.paging.next" class="util-loader"></div>
        <p v-if="messages.paging && messages.paging.next">Chargement des anciens messages</p>
        <p v-else>Debut de la conversation</p>
      </li>
    </ul>
    <ul v-else class="discussion-order scrollable">
      <li v-for="index in 8" :key="index">
          
          <div v-if="Math.random() > 0.5" class="message-received content-loading">
           <div class="message-received-content">
            <div class='message-received-content-text text'>
               <p>{{ 'w'.repeat(5+Math.random()*100) }}</p>
             </div>
           </div>
           <div class="container-actions-message"></div>
          </div> 
          <div v-else class="message-sent content-loading">
            <div class="message-sent-content">

             
              <div class='message-sent-content-text text'>    
                <p>{{ 'w'.repeat(5+Math.random()*100) }}</p>            
              </div>     
            </div>
            <div class="container-actions-message"></div>
            
          </div>
      </li>
    </ul>

    <!-- send message -->
    <FormSendMessage :acceptTypeMedia="'image/*'" v-on:onSubmitMessage="onSubmitMessage"></FormSendMessage>
    
  </div>

  <!-- savoir si c est un message recus ou envoyé  {{ discut.from.name }} {{ page.name }} sont egal. -->
</template>

<script>
import Moderation from './../../mixins/Moderation'



import 'emoji-mart-vue-fast/css/emoji-mart.css'
import FormSendMessage from './FormSendMessage'
import AvatarComponent from './../utils/avatar.vue'
import SelectComponent from './../utils/select.vue'
import ContextMenu from './../contextMenu/contextMenuInit.vue'

export default {
  name: 'component-discussion-instagram',

  mixins: [Moderation],

  components: {
    FormSendMessage,
    AvatarComponent,
    SelectComponent,
    ContextMenu
  },

  props: {

    messages : Object,
    infoConversation : Object,
    infoUser : Object,
    page: Object,
    event: Object,
    isLoading : {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      showEmojiPicker: false,
      message: null,
      user: null,
      url: [],
      fileInput: [], // Store our uploaded file
      fileInputParesed: []
    }
  },

  mounted() {
    if (this.$refs.discussionScrool) {
      this.$refs.discussionScrool.addEventListener('scroll', this.handleScroll);
    }

  },

  beforeDestroy() {
    if (this.$refs.discussionScrool) {
      this.$refs.discussionScrool.removeEventListener('scroll', this.handleScroll);
    }
  },

  methods: {
    changeStatus(status){
      this.$emit('changeStatus', status)
    },

    onChange() {
      this.fileInput = [...this.$refs.file.files]
      console.log('this.$refs.file', this.$refs.file)
    },
    
    previewFiles(e) {
      console.log('nombre d images', e.target.files.length)
      console.log(e.target.files)
      for (var file of e.target.files) {
        this.url.push(URL.createObjectURL(file))
      }
      console.log(this.url)
    },

    async onSubmitMessage(formData,filesUrl = []) {
      if (formData.get('message')) {
        this.messages.data = [{
          "created_time":new Date().toISOString(),
          "from":{"username":this.page.name,"name":this.page.name,"id": this.page.network_id},
          "id":"",
          "message": formData.get('message'),
          "to":{
            "data":[{"username":"","id":""}]
          },
          "status" : ""
        },...this.messages.data]
      } 
      

      if(formData.get('file[]') && filesUrl.length > 0) {
        filesUrl.forEach(url => {
          console.log("url",url)
          this.messages.data = [{
            "created_time":new Date().toISOString(),
            "from":{"username":this.page.name,"name":this.page.name,"id": this.page.network_id},
            "message": "",
            "attachments":{
              "data":[
                {
                  "image_data":{
                    "url":url,
                  }
                }
              ],
            },
            "id":"",
            "to":{
              "data":[{"username":"","id":""}]
            },
            "status" : ""
        },...this.messages.data]
        });    
      }
      
      let recipientId = this.infoConversation.participants.data.find(user => user.id !== this.page.network_id).id
      
      let result = await this.sendMessage(this.page, recipientId, formData)

      if (result.body.success) {
        this.messages.data[0].status = "sent"
        if (filesUrl.length > 0 && formData.get('message'))  this.messages.data[1].status = "sent"
      }else{
        this.messages.data[0].status = "echec"
        if (filesUrl.length > 0 && formData.get('message'))  this.messages.data[1].status = "echec"
      }

      
    },
    
    clickOptionMessage(id, nameOption) {
      switch (nameOption) {
          case 'deleteMessage':

          break
      }
    },

    dateFormat(dateMessage) {
      if (typeof dateMessage !== "object") {
        dateMessage = new Date(dateMessage)
      }
      let date = new Date()
      let tab_Month= ["Jan", "Févr", "Mars", "Avr", "Mai", "Juin", "Juill", "Août", "Sept", "Oct", "Nov", "Déc"];

      if((date.getDate().toString() + date.getMonth().toString() + date.getFullYear().toString()) == (dateMessage.getDate().toString() + dateMessage.getMonth().toString() + dateMessage.getFullYear().toString())){
          return "Aujourd'hui à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
          
      }else if((date.getFullYear() == dateMessage.getFullYear()) && (date.getMonth() == dateMessage.getMonth()) && dateMessage.getDate() == (date.getDate() - 1)){
          return "Hier à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
      }else{
          return "Le "+dateMessage.getDate()+" "+tab_Month[dateMessage.getMonth()]+" "+dateMessage.getFullYear()+" à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes()  ;
      }
    },
    
    handleScroll(e) {
      console.log('handleScroll')
      if (e.target.scrollHeight - (e.target.offsetHeight - e.target.scrollTop) < 20) {
        this.$refs.discussionScrool.removeEventListener('scroll', this.handleScroll);
        this.getOtherMessage()
      }
    },

    getRecipientInfo() {
     return this.infoConversation.participants && this.infoConversation.participants.data ? this.infoConversation.participants.data.filter(participant => participant.id !== this.event.page)[0] : this.event.user.username
    },

    async getOtherMessage() {
      
      if (this.messages.paging.next) {

        let request = await this.$http.get(this.messages.paging.next, {}).then(res => res, err => err);
        console.log(request.body)
        
        if (request.body && request.body.data) {

          if (request.body.paging) this.messages.paging = request.body.paging
    
          let newArray = (this.messages.data).concat(request.body.data)
          this.messages.data = newArray
        }
    
        if (request.body.paging && this.messages.paging.next) {
          this.$refs.discussionScrool.addEventListener('scroll', this.handleScroll);
        }else{
          this.messages.paging = {}
        }
        
      }
    },

  
  },

  computed: {
      getIndexLastMessageSend() {
        return this.messages.data.findIndex((discut) => discut.status && discut.status == 'sent')
      }
  },

  watch: {
    event() {
      if (this.$refs.discussionScrool) {
        this.$refs.discussionScrool.addEventListener('scroll', this.handleScroll);
      }
    }
  }
}
</script>